import { createConsentCore } from '@digiwedge/cmp-consent-core';

export const consentCore = createConsentCore({
  version: 1,
  store: 'localStorage',
  initial: {
    analytics: false,
    marketing: false,
    functional: false,
  },
});

export const consentStrings = {
  locale: 'en',
  title: 'Cookie Preferences',
  description:
    'We use cookies to keep the site reliable and to understand how visitors engage with YOLO Telecoms.',
  buttons: {
    acceptAll: 'Accept All',
    rejectAll: 'Reject All',
    manage: 'Manage',
    save: 'Save Preferences',
    cancel: 'Cancel',
  },
  categories: {
    essential: {
      label: 'Essential',
      description: 'Required for core site functionality and security.',
      cookies: 'Session and security cookies.',
    },
    analytics: {
      label: 'Analytics',
      description: 'Help us improve the site by measuring usage trends.',
      cookies: 'Analytics cookies (when enabled).',
    },
    marketing: {
      label: 'Marketing',
      description: 'Support relevant offers and campaign measurement.',
      cookies: 'Marketing pixels (when enabled).',
    },
    functional: {
      label: 'Functional',
      description: 'Remember preferences and enhance site features.',
      cookies: 'Consent preferences (cmp.consent.v1).',
    },
  },
};
